// extracted by mini-css-extract-plugin
module.exports = {"message-list":"message-list__1jRl9","message-list__content":"message-list__content__3TyF4"};